module.exports = __webpack_public_path__ + "static/media/trezor.f60a7675.svg";